// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCSw-4y5VlUM5GIQTd8eTQMi6Z4Ey603lQ",
  authDomain: "diamondsandrust-chatroom.firebaseapp.com",
  projectId: "diamondsandrust-chatroom",
  storageBucket: "diamondsandrust-chatroom.firebasestorage.app",
  messagingSenderId: "58858918929",
  appId: "1:58858918929:web:d4915e48ca2f2c773dcdb0",
  measurementId: "G-QVVK8Y3HZD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const Db = getFirestore(app);